@import 'db-ui-core.general';
@import 'card';

:host {
  @extend html;
  @extend body;
}

.cmp-card {
  // Some custom styling especially for the DB UI Elements homepage
  // TODO: Migrate to DB UI Core
  padding: 1rem 1rem 1rem 0.5rem;

  figure {
    margin: 0;
  }

  svg,
  img[src$='.svg'] {
    margin: auto 0;
  }
}
